import clsx from 'clsx';
import Compartir from 'components/3cat/Compartir';
import Imatge from 'components/3cat/Imatge';
import Text from 'components/3cat/Text';
import __isEmpty from 'lodash/isEmpty';
import styles from './textItemDestacat.module.scss';

export default function TextItemDestacat(props) {
    const { items, share, isWebviewActive, estil } = props;
    const { titol, entradeta, imatges } = items;
    const arrayImatges = imatges?.imatge ? imatges.imatge : imatges;

    const stylesModul = clsx({
        [styles.itemDestacat]: true,
        [styles[estil]]: !__isEmpty(estil)
    });

    return items ? (
        <>
            <div className={stylesModul}>
                <div>
                    <Text tag='h1' className={styles.titol} text={titol} />
                    {!__isEmpty(entradeta) && <Text tag='p' className={styles.entradeta} text={entradeta} />}
                </div>
                {share && (
                    <div className={styles.share}>
                        <Compartir className='icona_compartir' titol={titol} isWebviewActive={isWebviewActive} />
                    </div>
                )}
            </div>
            <div className={styles.imatgewrapper}>
                {!__isEmpty(arrayImatges) && (
                    <>
                        <Imatge
                            className={styles.imatge}
                            imatges={arrayImatges}
                            tipus='web_background'
                            width='1280'
                            height='720'
                            crop='1280x720'
                            alt={titol}
                        />
                        <span className={styles.imatgeBg}></span>
                    </>
                )}
            </div>
        </>
    ) : (
        <></>
    );
}
